module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb-item', {
    staticClass: "ml-2 mr-2",
    staticStyle: {
      "border": "5px"
    },
    on: {
      "click": function($event) {
        _vm.addMessage()
      }
    }
  }, [_c('b-badge', {
    staticStyle: {
      "font-size": "100%",
      "color": "red"
    }
  }, [_c('b', [_vm._v("Notes")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a84d984","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/addMessage.vue
// module id = 2597
// module chunks = 0